import * as React from "react";
import {ConfirmModal} from "@falcon/plugin-falcon-journey";
import {Image} from "@falcon/services";

interface IProps {
    image: Image
    onRemove: any
}

export function ImagePanel(props: IProps) {

    const [showRemoveConfirmation, setShowRemoveConfirmation] = React.useState(false);

    const handleConfirm = (): void => {
        props.onRemove(props.image.id);
        setShowRemoveConfirmation(false);
    };

    return (
        <>
            <div className="p-2 bg-white rounded-small d-flex justify-content-between">
                <img src={props.image.base64} alt="Uploaded image"/>
                <img src="/img/close-icon.svg" alt="Remove icon" onClick={() => setShowRemoveConfirmation(true)}/>
            </div>
            <ConfirmModal show={showRemoveConfirmation}
                          onHide={() => setShowRemoveConfirmation(false)}
                          onConfirm={handleConfirm}
                          confirmButtonText="Yes, please">
                <div className="fs-20 font-weight-bold font-family-display">
                    Are you sure you want to delete this image of your item?
                </div>
            </ConfirmModal>
        </>
    )
}
